// removed by extract-text-webpack-plugin
module.exports = {"button":"Button__button___UE6fb","xl":"Button__xl___1WBeO","md":"Button__md___1MnAp","white":"Button__white___1kNim","blueDark":"Button__blueDark___333J6","greenDecide":"Button__greenDecide___FYb9-","loading":"Button__loading___1-RhF","spin":"Button__spin___2shmg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Button.scss
// module id = ub6z
// module chunks = 0